var render = function render(){var _vm=this,_c=_vm._self._c;return _c('k-button',{attrs:{"text":_vm.text,"disabled":!_vm.userPermissions.create,"variant":"info"},on:{"click":_vm.emitClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }